export const lightBg = () => ({ item: { backgroundColor: '#F4F6F9' } });

export const fixedWidthCell = () => ({
  item: { width: '200px' },
});
